import React, { useState, useEffect } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "../Input/constantInput/constantInput";

const UcdDealerFilter = ({ applyFilter }) => {
  const parseLocalStorage = () => {
    try {
      const data = JSON.parse(window.localStorage?.filterData || "{}");
      return {
        business_name: data.business_name || ""
      };
    } catch {
      return {
        business_name: ""
      };
    }
  };

  const initialFilterInputs = parseLocalStorage();

  const [filterFieldsData, setFilterFieldsData] = useState({
    business_name: initialFilterInputs.business_name
  });


  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
        business_name: storedData.business_name ? storedData.business_name : ""
    });
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
            business_name: filterFieldsData.business_name ? filterFieldsData.business_name : ""
        });
      }}
    >
      <ConstantInput
        label={"Business Name"}
        value={window.localStorage?.filterData && window.localStorage?.filterData ? JSON.parse(window.localStorage?.filterData)['business_name'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, business_name: val });
        }}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(initialFilterInputs);
            applyFilter({
              business_name: ""
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default UcdDealerFilter;
